// extracted by mini-css-extract-plugin
export default {"black":"Paragraph_black__a1z3z","green":"Paragraph_green__AUb5r","error":"Paragraph_error__8z7yh"};